import { TrainingEventVisitInformation } from './training-event-visit-information.model';
import { Objective } from './training-event.objective';
import { ETraineeType } from '../../../precheckin/models/enums/trainee-type.enum';
import { Timing } from '../enum/timing.enum';
import { TsaApprovalStatus } from '../enum/tsa-approval-status.enum';
import { ITrainingEvent } from '../interfaces/training-event.interface';
import { ReservationAccountExecutive } from '../reservation/reservation-account-executive.model';
import { ReservationDocument } from '../reservation/reservation-document.model';

export class TrainingEvent {
  public geminiReservationId: string; // main identifier used internally in our systems
  public schedulerReservationId: string; // external identifier (displayed to pilots)
  public name: string;
  public startDate: Date;
  public endDate: Date;
  public reservationStartDate?: Date = null;
  public reservationEndDate?: Date = null;
  public locationName: string;
  public trainingLocationWebsite: string;
  public trainingLocationName: string;
  public trainingLocationDisplayName: string;
  public trainingLocationStreetAddress: string;
  public trainingLocationSiteId: string;
  public orderProgramType: string;
  public trainingType: ETraineeType;
  public reservationAccountExecutive: ReservationAccountExecutive;
  public timing: Timing;
  public geminiAircraftId: string;
  public starsCourseId: string;
  public hasTSA: boolean; // deprecated and should always be false from backend
  public tsaApprovalStatus: TsaApprovalStatus;
  public hasIACRA: boolean;
  public hasDocumentUpload: boolean;
  public hasPreCheckin: boolean;
  public hasPreCheckinIos: boolean;
  public hasPreCheckinAndroid: boolean;
  public hasPreCheckinWeb: boolean;
  public isFTO: boolean;
  public isContactCardDisplayedWeb: boolean;
  public reservationId: string; // non-reservation identifier coupled with the isFTO flag
  public reservationDocuments: ReservationDocument[] = [];
  public trainingInformation: TrainingEventVisitInformation;
  public isPinned: boolean;
  public regulatoryAgencies: string[] = [];
  public objectives: Objective[] = [];
  public hasAccessBadge: boolean = true;

  constructor(data?: ITrainingEvent, pinnedEvents?: string[]) {
    this.startDate = new Date();
    this.endDate = new Date();

    this.timing = Timing.Upcoming;
    this.reservationDocuments = [];
    this.reservationId = '';

    if (!data) {
      return;
    }
    this.geminiReservationId = data.geminiReservationId;
    this.schedulerReservationId = data.schedulerReservationId;
    this.name = data.name;
    this.locationName = data.locationName;
    this.trainingLocationWebsite = data.trainingLocationWebsite;
    this.trainingLocationName = data.trainingLocationName;
    this.trainingLocationDisplayName = data.trainingLocationDisplayName;
    this.trainingLocationStreetAddress = data.trainingLocationStreetAddress;
    this.trainingLocationSiteId = data.trainingLocationSiteId;
    this.orderProgramType = data.orderProgramType;
    this.trainingType = data.trainingType;
    this.reservationAccountExecutive = data.reservationAccountExecutive;
    this.timing = data.timing;
    this.geminiAircraftId = data.geminiAircraftId;
    this.starsCourseId = data.starsCourseId;
    this.hasTSA = data.hasTSA;
    this.tsaApprovalStatus = data.tsaApprovalStatus;
    this.hasIACRA = data.hasIACRA;
    this.hasDocumentUpload = data.hasDocumentUpload;
    this.hasPreCheckin = data.hasPreCheckin;
    this.hasPreCheckinWeb = data.hasPreCheckinWeb;
    this.hasPreCheckinAndroid = data.hasPreCheckinAndroid;
    this.hasPreCheckinIos = data.hasPreCheckinIos;
    this.hasAccessBadge = data.hasAccessBadge;
    this.geminiReservationId = data.geminiReservationId;
    this.isFTO = data.isFTO;
    this.isContactCardDisplayedWeb = data.isContactCardDisplayedWeb;
    this.reservationId = data.reservationId;
    this.isPinned = false;
    if (pinnedEvents) {
      this.isPinned = this.isFTO
        ? pinnedEvents.includes(this.reservationId)
        : pinnedEvents.includes(this.geminiReservationId);
    }
    if (data.startDate) {
      this.startDate = new Date(data.startDate);
    }
    if (data.endDate) {
      this.endDate = new Date(data.endDate);
    }
    if (data.reservationStartDate) {
      this.reservationStartDate = new Date(data.reservationStartDate);
    }
    if (data.reservationEndDate) {
      this.reservationEndDate = new Date(data.reservationEndDate);
    }
    if (data.reservationDocuments) {
      for (const reservationDocument of data.reservationDocuments) {
        this.reservationDocuments.push(
          new ReservationDocument(reservationDocument)
        );
      }
    }
    this.trainingInformation = new TrainingEventVisitInformation(
      data.trainingInformation
    );
    this.regulatoryAgencies = data.regulatoryAgencies;

    if (data.objectives) {
      for (const objective of data.objectives) {
        this.objectives.push(new Objective(objective));
      }
    }
  }
}
